import { path } from '@soltalabs/ramda-extra'
import React from 'react'

import { getAddressApiRequest } from '../../../api/mapbox'

import { isClickOnMapOverlay } from './helpers'
import { redux } from './redux'
import { MapView } from './view'

class MapViewContainer extends React.Component {
  state = {
    viewport: {
      width: '100%',
      height: '100%',
      latitude: -26.50,
      longitude: 145.50,
      zoom: 3.1,
      offSetTop: -20,
    },
  }

  componentDidMount() {
    this.props.dispatchGetProducts()
    this.props.dispatchFetchForecasts()
  }

  onViewportChange = (viewport) => {
    this.setState({
      viewport: { ...this.state.viewport, ...viewport },
    })
  }

  onGeocoderViewportChange = (viewport) => {
    const geocoderDefaultOverrides = { transitionDuration: 500 }

    this.onViewportChange({
      ...viewport,
      ...geocoderDefaultOverrides,
    })
  }

  onAddJob = ({ jobName, scheduledAt, productId }) => {
    const { sortBy, addJobLocation, addJobAddress, dispatchAddJob } = this.props

    const jobValues = {
      jobName,
      address: addJobAddress,
      addressLocation: {
        type: 'Point',
        coordinates: [addJobLocation.longitude, addJobLocation.latitude],
      },
      scheduledAt,
      productId,
    }

    dispatchAddJob(jobValues, sortBy)

    this.onClosePopup()
  }

  onMapClick = (event) => {
    // react-map-gl delays `click` ~300ms to rule out a double-click. By then a
    // popup closed by its own button (e.g. ADD) has unmounted and no longer
    // swallows the click, so it would drop a new job pin under the button.
    if (isClickOnMapOverlay(event.srcEvent && event.srcEvent.target)) {
      return
    }

    const {
      dispatchSetAddJobAddress,
      dispatchSetAddJobLocation,
      dispatchSetSelectedJob,
    } = this.props
    const [longitude, latitude] = event.lngLat

    getAddressApiRequest({ latitude, longitude }).then((response) => {
      const address = path(['features', 0, 'place_name'], response)
      dispatchSetAddJobAddress(address)
    })

    dispatchSetAddJobLocation({ latitude, longitude })
    dispatchSetSelectedJob(null)

    const viewport = { latitude, longitude, transitionDuration: 500 }
    this.onViewportChange(viewport)
  }

  onClosePopup = () => {
    const {
      dispatchSetAddJobAddress,
      dispatchSetAddJobLocation,
      dispatchSetSelectedJob,
    } = this.props
    dispatchSetAddJobAddress(null)
    dispatchSetAddJobLocation(null)
    dispatchSetSelectedJob(null)
  }

  render() {
    const { mapRef } = this.props
    return (
      <MapView
        {...this.props}
        {...this.state}
        mapRef={mapRef}
        onViewportChange={this.onViewportChange}
        onGeocoderViewportChange={this.onGeocoderViewportChange}
        onMapClick={this.onMapClick}
        onAddJob={this.onAddJob}
        onClosePopup={this.onClosePopup}
      />
    )
  }
}

const Map = redux(MapViewContainer)

export { Map }
